import { loadScript } from "@wise-emotions/web-utils";

// eslint-disable-next-line @typescript-eslint/ban-types
const loadGoogleReCaptcha = async (apiKey: string, callback?: Function) => {
  if (
    typeof window !== "undefined" &&
    typeof window.grecaptcha === "undefined"
  ) {
    loadScript({
      url: `https://www.google.com/recaptcha/api.js?render=${apiKey}`,
    });
  }

  callback?.();
};

export default loadGoogleReCaptcha;
